(function () {
  'use strict';
  if (window.__clyroVisibleVideo) return;
  window.__clyroVisibleVideo = true;
  var videos = new Set();
  var inView = new Set();
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function sync(video) {
    if (!video.isConnected) { if (observer) observer.unobserve(video); videos.delete(video); inView.delete(video); return; }
    if (!inView.has(video) || document.hidden || reduced.matches || (navigator.connection && navigator.connection.saveData)) {
      video.pause(); video.controls = true; return;
    }
    video.muted = true;
    var play = video.play();
    if (play && play.catch) play.catch(function () { video.controls = true; });
  }
  var observer = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) inView.add(entry.target); else inView.delete(entry.target);
      sync(entry.target);
    });
  }, { threshold: 0.15 }) : null;
  function init() {
    document.querySelectorAll('[data-clyro-visible-video]').forEach(function (video) {
      if (videos.has(video)) return;
      videos.add(video);
      if (observer) observer.observe(video); else video.controls = true;
    });
  }
  document.addEventListener('visibilitychange', function () { videos.forEach(sync); });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    videos.forEach(function (video) {
      if (event.target.contains(video)) { video.pause(); if (observer) observer.unobserve(video); videos.delete(video); inView.delete(video); }
    });
  });
  init();
})();
